/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ClosedStatusFilter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import StatusTooltip from './StatusTooltip/index'
import TagStatusShortButton from 'DesignSystem/TagStatusShortButton/index'



/** @type {import('Simple/types.js').View} */
export default function ClosedStatusFilter({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/FilterByStatus/ClosedStatusFilter",
  onChange,
  isHovered
  
}) {
let tabSelectedStatusesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.statuses',
format: fromFormat.isSelectedStatusClosed,
})
let tabSelectedStatusesChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.statuses',
formatOut: fromFormat.toggleSelectedStatusClosed,
})
  return (<React.Fragment
>
<TagStatusShortButton
  viewPath={`${viewPath}/TagStatusShortButton`}
 marginLeft={2}
 text="C"
 data="tab.selected.statuses"
 format="/Data/format.js isSelectedStatusClosed"
 formatOut="/Data/format.js toggleSelectedStatusClosed"
 isSelected={tabSelectedStatusesValueData}
 onClick={tabSelectedStatusesChangeData}
>
{childProps => (
<StatusTooltip
{...childProps}
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!childProps.isHovered}
 flowContent={childProps.isHovered}
/>
)}
</TagStatusShortButton>
{children}
</React.Fragment>)
}